import { AdminConsoleUsersApi } from '@portal/pkg-api/admin-console'
import { InfoApi } from '@portal/pkg-api/auth'
import { data } from '@portal/pkg-api/helpers'

const prefix = 'admin-console.users'

export const UserQueries = {
  orgSettings: (orgId?: number) => ({
    queryKey:
      orgId === undefined
        ? [prefix, 'user-admin-org-settings']
        : [prefix, 'user-admin-org-settings', orgId],
    queryFn: () => data(AdminConsoleUsersApi.getOrgSettings(orgId)),
    staleTime: Infinity,
  }),
  list: (orgId?: number) => ({
    queryKey: orgId === undefined ? [prefix, 'list'] : [prefix, 'list', orgId],
    queryFn: () => data(AdminConsoleUsersApi.listUsers(orgId)),
  }),
  detail: (id: number, orgId?: number) => ({
    queryKey: orgId === undefined ? [prefix, 'detail', id] : [prefix, 'detail', id, orgId],
    queryFn: () => data(AdminConsoleUsersApi.getUser(id, orgId)),
  }),
  currentUserId: () => ({
    queryKey: ['shared.userInfo.userInfo'],
    queryFn: () => data(InfoApi.getUserInfo()),
    staleTime: Infinity,
    select: (userInfo: { real?: { id?: number } }) => userInfo?.real?.id,
  }),
}
